var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"mx-auto"},[_c('navbar-cat',{attrs:{"categories":_vm.categories,"width_switch":_vm.width_small}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }